import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-ia-user-access',
  templateUrl: './ia-user-access.component.html',
  styleUrls: ['./ia-user-access.component.scss']
})
export class IaUserAccessComponent implements OnInit {
  IAMarksForm: FormGroup;
  SuperExamForm: FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  userPermission: any;
  filteredListCourse: any[];
  filteredCollegeList: any[];
  filteredListExam: any[];
  filteredListBranch: any[];
  filteredsubjectList: any[];
  HeadList: any[];
  message: any;
  closeMessage: any;
  finalPayload: any[] = [];
  Table = false;
  UpdateBtn = false;
  SaveBtn = false;
  isBranch: boolean;
  examList: any[];
  CourseList: any[];
  UserCollege
  subcode: string;
  collegeList: any;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  subjectList: any[];
  emid: any;
  BranchList: any;
  sub: any;
  subName: any;
  filteredListHead: any[];
  subId: any;
  selectedSupervisors: any[];
  passMarks: any;
  maxMarks: any;
  head: any;
  submitpayload: any;
  headTableData: any[];
  userList: any;
  errMsg: string;
  StuArray: FormArray;
  filteredUserList: any;
  IAmarks = 0
  currentDate: Date;
  headcode: any;
  IAmarksCounts
  assignTableData: any[];
  IsFile = false;
  utp: string;
  formativeUesrASSCreate = true;
  formativeUserASSUpdate = true;
  isSelectAll: boolean = false;  // Flag to disable other options
  selectedSubject = [];  // Array to store selected college codes
  allSubjectsSaved: boolean = false;
  subiddddddddddd: any;
  get HeadArray(): FormArray {
    return this.IAMarksForm.get('HeadArray') as FormArray;
  }
  constructor(private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    let id = ''
    this.IsFile = false
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isSelectAll = true
    this.allSubjectsSaved = false;
    this.IAMarksForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      EmId: new FormControl(''),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      EsParentId: new FormControl(''),
      StuArray: new FormArray([]),
      HeadArray: new FormArray([]),
    });
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'IA Marks User Access' && element.PCreate == false) {
          this.formativeUesrASSCreate = false;
        }
        if (element.PageName == 'IA Marks User Access' && element.PUpdate == false) {
          this.formativeUserASSUpdate = false;
        }
      });
    }
    this.fetchSession(id);
    this.getClg();
    this.currentDate = new Date();

  }
  getStuArrayControls() {
    return (this.IAMarksForm.get('StuArray') as FormArray).controls;
  }

  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getCourse(data) {
    this.spinner.show();
    this.closeMessage = '';
    this.message = ''
    this.finalPayload = []
    let payload2 = this.IAMarksForm.value
    console.log(payload2)
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.IAMarksForm.controls['EsParentId'].setValue([]);
    this.selectedSubject = [];
    this.isSelectAll = false;
    this.IAMarksForm.controls['course'].setValue('');
    this.IAMarksForm.controls['Branch'].setValue('');
    this.IAMarksForm.controls['EmId'].setValue('');
    // this.IAMarksForm.controls['EsParentId'].setValue('');
    this.IAMarksForm.controls['EsId'].setValue('');
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.examList = []
    this.CourseList = [];
    const payload = {};
    payload['CgCode'] = payload2.college;
    payload['SessionId'] = payload2.SessionId;
    console.log('payload',payload )
    this.umsService.getCourse(payload).subscribe(res => {
      console.log(res)
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getClg() {
    this.spinner.show();
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.Table = false;
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.IAMarksForm.controls['EsParentId'].setValue([]);
    this.selectedSubject = [];
    this.isSelectAll = false;
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }

  getExamList(e) {
    this.spinner.show();
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.Table = false;
    this.filteredsubjectList = [];
    this.examList = []
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = e;
    this.filteredsubjectList = [];
    this.examList = []
    this.IAMarksForm.controls['EsParentId'].setValue([]);
    this.selectedSubject = [];
    this.isSelectAll = false;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();

    });
  }



  getSubject(e) {
    this.spinner.show();
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.closeMessage = '';
    this.message = ''
    this.isBranch = false;
    this.Table = false;
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.IAMarksForm.controls['Branch'].setValue('');
    this.IAMarksForm.controls['EsId'].setValue('');
    this.subjectList = []
    this.IAMarksForm.controls['EsParentId'].setValue([]);
    this.selectedSubject = [];
    this.isSelectAll = false;
    this.emid = e.EmId;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {

        this.spinner.hide();
        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element)

          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      });
    }

  }


  fetchBranch(id) {
    this.spinner.show();
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    this.IAMarksForm.controls['EsId'].setValue('');
    this.IAMarksForm.controls['EsParentId'].setValue([]);
    this.selectedSubject = [];
    this.isSelectAll = false;
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }


  getStr(e) {
    this.spinner.show();
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.Table = false;
    this.filteredsubjectList = [];
    this.subjectList = []
    this.HeadList = [];
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.IAMarksForm.value.Branch;
    this.IAMarksForm.controls['EsParentId'].setValue([]);
    this.selectedSubject = [];
    this.isSelectAll = false;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();
        });
      }
      else {
        this.subjectList = [];
        this.filteredsubjectList = [];

      }

    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  subjectClick(data) {
    console.log('data',data)
    this.spinner.show();
    this.sub = data.EsCode
    this.subName = data.EsName
    this.closeMessage = ''
    this.message = ''
    this.HeadList = [];
    this.filteredListHead = [];
    this.subcode = data.EsCode;
    this.subId = data.EsId
    this.finalPayload = []
    this.selectedSupervisors = [];
    const payload = {};
    payload['EsId'] = data.EsId;
    this.cdr.detectChanges();
    const creds = this.IAMarksForm.get('HeadArray') as FormArray;
    creds.clear();
    console.log('payload',payload)
    this.umsService.getStuIASub(payload).subscribe(res => {
console.log('res.data',res.data)
      this.spinner.hide();
      if (res.status) {
        this.Table = true;
        this.HeadList = res.data;
        this.passMarks = this.HeadList[0].EsPassMarks
        this.maxMarks = this.HeadList[0].EsMaxMarks
        this.head = this.HeadList[0].EsCode
        this.filteredListHead = this.HeadList.slice();
        this.userClick()
        this.getIAMarksHead(data.EsId)
      }
      else {
        this.HeadList = [];
        this.IAMarksForm.controls['EsId'].setValue('');
        this.Table = false;
      }

    }
    , (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.HeadList = [];
      this.IAMarksForm.controls['EsId'].setValue('');
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  )
  }

  getIAMarksHead(esId: string) {
    this.spinner.show();
    this.submitpayload = this.IAMarksForm.value;

    let payload = {
      SnNo: this.submitpayload['SessionId'],
      CgCode: this.submitpayload['college'],
      CoCode: this.submitpayload['course'],
      Branch: this.submitpayload['Branch'],
      EmId: this.submitpayload['EmId'],
      EsIdIASub: esId
    };

    this.umsService.getIAMarksHeadData(payload).subscribe(
      (res) => {
        this.spinner.hide();
        const creds = this.IAMarksForm.get('HeadArray') as FormArray;
        creds.clear();

        if (res.status && res.data?.length) {
          this.headTableData = res.data;
          this.Table = true;
          this.SaveBtn = false;
          this.UpdateBtn = true;

          this.headTableData.forEach((element, i) => {
            const selectedUser = this.userList.find(user => user.LoginId === element['LoginId']);
            creds.push(
              this.fb.group({
                SrNo: new FormControl(i + 1),
                Name: new FormControl(element['LoginName'] || ''),
                CgCode: new FormControl(element['CgCode']),
                CoCode: new FormControl(element['CoCode']),
                EhDefName: new FormControl(element['EhDefName']),
                EmId: new FormControl(element['EmId']),
                Branch: new FormControl(element['Branch']),
                EsIdIASub: new FormControl(element['EsIdIASub']),
                EsIdSubHead: new FormControl(element['EsIdSubHead']),
                LoginId: new FormControl(element['LoginId'], Validators.required),
                SnNo: new FormControl(element['SnNo']),
                UserId: new FormControl(element['User Id']),
                LoginName: new FormControl(selectedUser?.LoginFullName || '')
              })
            );
          });
        } else {
          this.Table = true;
          this.SaveBtn = true;
          this.UpdateBtn = false;

          this.headTableData = this.HeadList.map((element, i) => ({
            EsName: element['EsName'],
            EsId: element['EsId'],
            LoginId: element['LoginId'] || ''
          }));

          this.headTableData.forEach((element, i) => {
            creds.push(
              this.fb.group({
                SrNo: new FormControl(i + 1),
                EhDefName: new FormControl(element['EsName']),
                EsId: new FormControl(element['EsId']),
                LoginId: new FormControl(element['LoginId'], Validators.required),
              })
            );
          });
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }


  async Save() {
    const headArray = this.IAMarksForm.get('HeadArray') as FormArray;

    headArray.controls.forEach(control => {
      control.get('LoginId')?.markAsTouched();
    });

    if (this.IAMarksForm.invalid) {
      return;
    }
    try {
      await this.saveIaMarksThreshold();
      this.showSuccessMessage("Submitted Successfully");
    } catch (error) {
      this.showErrorMessage(this.errMsg || "An error occurred");
    }

  }

  showSuccessMessage(message: string) {
    let data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-check'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      this.userClick();
    });
  }

  showErrorMessage(message: string) {
    let data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      this.userClick();
    });
  }

  async saveIaMarksThreshold() {
    return new Promise<void>((resolve, reject) => {
      this.spinner.show();
      this.submitpayload = this.IAMarksForm.value;
      this.finalPayload = [];

      this.filteredsubjectList.forEach((subject) => {
        const faSubHead = subject.children?.find(child => child.EsCode === 'IA');

        this.selectedSupervisors.forEach((element) => {
          const payload = {
            SnNo: this.submitpayload['SessionId'],
            CgCode: this.submitpayload['college'],
            CoCode: this.submitpayload['course'],
            EmId: this.submitpayload['EmId'],
            Branch: this.submitpayload['Branch'],
            IASub: subject.EsCode,                   // Subject code
            EsIdIASub: subject.EsId,                 // Subject ID
            IASubHead: element?.HeadCode || '',      // Head code from selection
            EsIdSubHead: faSubHead?.EsId || '',              // 🔑 FORMATIVE's EsId
            UserId: element?.supervisorId || ''              // Supervisor ID
          };

          this.finalPayload.push(payload);
        });
      });

      this.umsService.saveStuIAMarksUser(this.finalPayload).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            resolve();
            this.headTableData = [];
            this.selectedSupervisors = [];

            const creds = this.IAMarksForm.get('HeadArray') as FormArray;
            creds.clear(); // Clear previous data

            this.filteredsubjectList.forEach((subject) => {
              this.getIAMarksHead(subject.EsId);
            });

            this.allSubjectsSaved = true;
          } else {
            this.errMsg = res.message || "Error occurred while saving threshold";
            reject(this.errMsg);
          }
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.errMsg = error.error.message;
          reject(this.errMsg);
        }
      );
    });
  }

  async update() {
    if (this.IAMarksForm.invalid) {
      this.IAMarksForm.get('SessionId').markAsTouched();
      this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
      this.IAMarksForm.get('EmId').markAsTouched();
      this.IAMarksForm.get('EsParentId').markAsTouched();
      this.IAMarksForm.get('EsId').markAsTouched();

      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('IAmarks').markAsTouched();
        })
      }
    }
    else {
      try {
        await this.updateIaMarksThreshold();
        this.showSuccessMessage("Updated Successfully");
      } catch (error) {
        this.showErrorMessage(this.errMsg || "An error occurred");
      }
    }
  }
  async updateIaMarksThreshold(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.spinner.show();
      this.submitpayload = this.IAMarksForm.value;
      this.finalPayload = [];

      this.filteredsubjectList.forEach((subject) => {
        this.selectedSupervisors.forEach((supervisor) => {
          this.finalPayload.push({
            IAMarksId: supervisor.IAMarksId, // Required for update
            SnNo: this.submitpayload['SessionId'],
            CgCode: this.submitpayload['college'],
            CoCode: this.submitpayload['course'],
            EmId: this.submitpayload['EmId'],
            Branch: this.submitpayload['Branch'],
            IASub: subject.EsCode,
            EsIdIASub: subject.EsId,
            IASubHead: supervisor.HeadCode || '',
            EsIdSubHead: supervisor.HeadId || '',
            UserId: supervisor.supervisorId,
          });
        });
      });
      this.umsService.updateStuIAMarksUser(this.finalPayload).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            resolve();
            this.headTableData = [];
            this.selectedSupervisors = [];
            const creds = this.IAMarksForm.get('HeadArray') as FormArray;
            creds.clear();
            this.filteredsubjectList.forEach((subject) => {
              this.getIAMarksHead(subject.EsId);
            });

          } else {
            this.errMsg = res.message || "Error occurred while updating threshold";
            reject(this.errMsg);
          }
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.errMsg = error.error.message;
          reject(this.errMsg);
        }
      );
    });
  }

  clear() {
    this.SuperExamForm = this.fb.group({
      exam: new FormControl(''),
      user: new FormControl(''),
      UserArr: this.fb.array([]),
      ExamArr: this.fb.array([]),
    });
  }

  userClick() {
    this.clear();
    this.spinner.show();
    let payload = {}
    payload['CgId'] = this.IAMarksForm.value.college
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.userList = res.data;

        this.filteredUserList = this.userList.slice();
        this.cdr.detectChanges();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  onSupervisorChange(event: any, index: number, markData: any) {
    const data = this.userList.filter(user => user.LoginId === event.value);
    if (data.length > 0) {
      const updatedSupervisor = {
        HeadId: this.filteredListHead[index].EsId, // Use the index to get the correct head
        HeadCode: this.filteredListHead[index].EsCode,
        supervisorId: data[0].LoginId,  // Update with the selected supervisor's LoginId
        IAMarksId: markData.IAMarksId
      };
      const existingSupervisorIndex = this.selectedSupervisors.findIndex(
        supervisor => supervisor.HeadId === updatedSupervisor.HeadId
      );
      if (existingSupervisorIndex !== -1) {
        this.selectedSupervisors[existingSupervisorIndex] = updatedSupervisor;
      } else {
        this.selectedSupervisors.push(updatedSupervisor);
      }

    } else {
    }
    markData.LoginId = event.value;
  }
  selectAllSubjects() {
    if (this.isAllSubjectsSelected()) {
      this.selectedSubject = [];
      this.IAMarksForm.controls['EsParentId'].setValue([]); // Reset the selected values
    } else {
      this.selectedSubject = this.filteredsubjectList.map(item => item.EsId);
      this.IAMarksForm.controls['EsParentId'].setValue([...this.selectedSubject, 'selectAll']);
      this.filteredsubjectList.forEach(item => {
        this.subjectClick(item); // Call your existing logic here
      });
    }
    this.isSelectAll = this.isAllSubjectsSelected(); // Update the Select All state based on current selection
  }
isAllSubjectsSelected(): boolean {
  const selected = this.IAMarksForm.controls['EsParentId'].value || [];
  const subjectIds = this.filteredsubjectList.map(item => item.EsId);

  // Ignore 'selectAll' and check the rest
  const selectedWithoutSelectAll = selected.filter(val => val !== 'selectAll');
  return subjectIds.length > 0 &&
         subjectIds.every(id => selectedWithoutSelectAll.includes(id));
}

  // isAllSubjectsSelected(): boolean {
  //   return this.selectedSubject.length === this.filteredsubjectList.length;
  // }
}

